import 'twin.macro';

import IconNext from 'assets/svg/icons/play.inline.svg';
import { Link as LinkCore } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';

export default function LinkItem({ title, to, ...props }) {
	return (
		<LinkCore tw='no-underline!' to={to} {...props}>
			<div className='flex items-center justify-between w-110 p-03'>
				<p className='font-semibold text-09 text-main'>{title}</p>
				<IconNext width='0.7rem' height='0.7rem' />
			</div>
		</LinkCore>
	);
}

LinkItem.propTypes = {
	to: PropTypes.string.isRequired
};

LinkItem.defaultProps = {
	title: 'Dowiedz się więcej'
};
